export enum DragDropItemBlock {
  Root = 'DragDropItem',
}

export enum DragDropItemModifier {
  Modal = 'modal',
}
